import { Field, Float, ID, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateId } from '@ztechapps/common.utils'
import { StripeAchCreditTransfer } from './StripeAchCreditTransfer'
import { RelatedEntity } from '@ztechapps/common.contract'

@ObjectType()
export class InvoicePaymentItem {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateId() })
  _id: string

  @Field(() => Date)
  @Prop({ type: Date })
  date: Date

  @Field(() => Float)
  @Prop({ type: Number })
  amount: number

  @Field(() => String)
  @Prop({ type: String })
  source: string

  @Field(() => String)
  @Prop({ type: String })
  remarks: string

  @Field(() => StripeAchCreditTransfer)
  @Prop({ type: RelatedEntity })
  stripeAchCreditTransfer: StripeAchCreditTransfer

  @Field(() => String)
  @Prop({ type: String })
  paymentIntent: string
}
